// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import createReducer from '../createReducer';
import * as types from './actionTypes';

const initialState = {
  current_page: null,
};

const globalReducer = createReducer(initialState, {
  [types.SET_CURRENT_PAGE](state, action) {
    return {
      ...state,
      current_page: action.data.current_page,
    };
  },
});

export default globalReducer;
